// extracted by mini-css-extract-plugin
module.exports = {"elSection":"Section_elSection__eoC0B","vinWrapper":"Section_vinWrapper__m-aiU","warningModal":"Section_warningModal__3__2e"};